import React, { Component } from "react";
import AndtDTextBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/TextBoxWrapper";
import AndtDNumberBoxWrapper from "swfrontend/MDM/MDMAntdWrappers/NumberBoxWrapper";
import AndtDUploadWrapper from "swfrontend/MDM/MDMAntdWrappers/FileUploadWrapper";
import AntDSelectWrapper from "../../../../Components/CustomWrappers/AntDSelectWrapper";
import { FILE_UPLOAD_FIELDS, FILE_UPLOAD_RULES } from "../../../../constants";

class PaymentDetails extends Component {
  render() {
    const {
      uploadedFiles,
      fileConfigs,
      previewFile,
      formRef,
      isDisabled,
      currency,
      isAN22
    } = this.props;

    return (
      <div className="row form-box">
        <legend className="form-legend">Payment Details</legend>

        <div className="col-lg-6 col-md-12">
          <AntDSelectWrapper
            decorator="currency"
            id="Currency"
            required="true"
            disabled={isDisabled}
            label="Currency"
            message="Enter Currency"
            placeholder="Enter Currency"
            validators=""
            options={currency}
            primary_key_field="id"
            formRef={formRef}
          />
        </div>
      {!isAN22 &&(
        <>
        <div className="col-lg-6 col-md-12">
          <AndtDNumberBoxWrapper
            decorator="overall_monthly_quantity"
            id="Overall Monthly Quantity"
            required="true"
            disabled={isDisabled}
            label="Overall Monthly Buying in MT"
            message="Enter Overall Monthly Quantity"
            placeholder="Enter Overall Monthly Quantity"
            validators=""
            decimalLimit={3}
            formRef={formRef}
          />
        </div>

        <div className="col-lg-6 col-md-12">
          <AndtDNumberBoxWrapper
            decorator="annual_turnover"
            id="Annual Turnover"
            required="true"
            disabled={isDisabled}
            label="Annual Turnover (CR)"
            message="Enter Annual Turnover"
            placeholder="Enter Annual Turnover"
            validators=""
            decimalLimit={10}
            formRef={formRef}
          />
        </div>
      </>
      )}
        {fileConfigs[FILE_UPLOAD_FIELDS.balance_sheet_file] !== undefined && !isAN22 && (
          <div className="col-lg-6 col-md-12">
            <AndtDUploadWrapper
              name="balance_sheet_file"
              label="Balance Sheet File"
              decorator="balance_sheet_file"
              required={false}
              disabled={isDisabled}
              message="Please Select Balance Sheet File"
              removeFile={this.props.removeFile}
              validators={[]}
              files_limit={
                fileConfigs[FILE_UPLOAD_FIELDS.balance_sheet_file][
                  FILE_UPLOAD_RULES.totalfiles
                ]
              }
              file_size_limit_mb={
                fileConfigs[FILE_UPLOAD_FIELDS.balance_sheet_file][
                  FILE_UPLOAD_RULES.filesize
                ]
              }
              accept_file_type={
                fileConfigs[FILE_UPLOAD_FIELDS.balance_sheet_file][
                  FILE_UPLOAD_RULES.allowtypes
                ]
              }
              uploadFileList={uploadedFiles}
              addFile={this.props.addFile}
              previewFile={previewFile}
              formRef={formRef}
            />
          </div>
        )}
       
      </div>
    );
  }
}

export default PaymentDetails;
